export default __webpack_public_path__ + "static/rovo-cues-light-878d90a09b12eb85e6258cb86a9c0058b5a2fb303cbbe016e41b176ecf9afe7b.png";